import { getByIdPlanSelector } from '@gymaholic/packages'

export function existsByIdPlanSelector (id) {
  return (state, props) => {
    return getByIdPlanSelector(id)(state, props)
  }
}
